import React, {useMemo} from "react";
import {Box, MenuItem, Select, SelectChangeEvent} from "@mui/material";
import {IconStyleDto} from "../../dtos";
import {iconStyles} from "../../globals/constans";
import {getIconStyle} from "../../globals/globFunctions";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';


interface Props {
    iconStyle: IconStyleDto;
    setIconStyle: (iconStyle: IconStyleDto) => void;
    mainColor: string;
}

export const IconsStylesDropdown: React.FC<Props> = (
    {
        iconStyle,
        setIconStyle,
        mainColor
    }
) => {

    const handleOnChangeStyle = (event: SelectChangeEvent) => {
        const selectedStyle = getIconStyle(Number(event.target.value) || 1);
        setIconStyle(selectedStyle);
    }

    const iconsStyles = useMemo(() => {
        return iconStyles.map((iconStyle: IconStyleDto, index: number) => {
            const IconPromoComp = iconStyle.iconStyleData.promoCompIcon;
            const IconPageComp = iconStyle.iconStyleData.pageCompIcon;
            const IconLinkComp = iconStyle.iconStyleData.linkCompIcon;
            const IconVideoComp = iconStyle.iconStyleData.videoCompIcon;
            const IconImageComp = iconStyle.iconStyleData.imgCompIcon;
            const Icon360Comp = iconStyle.iconStyleData.img360CompIcon;
            return (
                <MenuItem key={`${iconStyle.iconStyleType}${index}`} value={iconStyle.value} sx={{
                    padding: "6px"
                }}>
                    <Box sx={{
                        display: `flex`,
                        alignItems: `center`,
                        justifyContent: "space-around",
                        width: "100%"
                    }}>
                        <Box sx={{
                            width: "32px",
                            height: "32px",
                            borderRadius: "50%",
                            // backgroundColor: "#ffffff",
                            "& > svg > rect": {
                                fill: (iconStyle.iconStyleType === 2 || iconStyle.iconStyleType === 3) ? mainColor : undefined
                            }
                        }}>
                            <IconPromoComp width={"100%"} height={"100%"}/>
                        </Box>
                        <Box sx={{
                            width: "32px",
                            height: "32px",
                            borderRadius: "50%",
                            // backgroundColor: "#ffffff",
                            "& > svg > rect": {
                                fill: (iconStyle.iconStyleType === 2 || iconStyle.iconStyleType === 3) ? mainColor : undefined
                            }
                        }}>
                            <IconPageComp width={"100%"} height={"100%"}/>
                        </Box>
                        <Box sx={{
                            width: "32px",
                            height: "32px",
                            borderRadius: "50%",
                            // backgroundColor: "#ffffff",
                            "& > svg > rect": {
                                fill: (iconStyle.iconStyleType === 2 || iconStyle.iconStyleType === 3) ? mainColor : undefined
                            }
                        }}>
                            <IconLinkComp width={"100%"} height={"100%"}/>
                        </Box>
                        <Box sx={{
                            width: "32px",
                            height: "32px",
                            borderRadius: "50%",
                            // backgroundColor: "#ffffff",
                            "& > svg > rect": {
                                fill: (iconStyle.iconStyleType === 2 || iconStyle.iconStyleType === 3) ? mainColor : undefined
                            }
                        }}>
                            <IconVideoComp width={"100%"} height={"100%"}/>
                        </Box>
                        <Box sx={{
                            width: "32px",
                            height: "32px",
                            borderRadius: "50%",
                            // backgroundColor: "#ffffff",
                            "& > svg > rect": {
                                fill: (iconStyle.iconStyleType === 2 || iconStyle.iconStyleType === 3) ? mainColor : undefined
                            }
                        }}>
                            <IconImageComp width={"100%"} height={"100%"}/>
                        </Box>
                        <Box sx={{
                            width: "32px",
                            height: "32px",
                            borderRadius: "50%",
                            // backgroundColor: "#ffffff",
                            "& > svg > rect": {
                                fill: (iconStyle.iconStyleType === 2 || iconStyle.iconStyleType === 3) ? mainColor : undefined
                            }
                        }}>
                            <Icon360Comp width={"100%"} height={"100%"}/>
                        </Box>
                    </Box>
                </MenuItem>
            )
        })
    }, [mainColor])
    return (
        <Select
            displayEmpty
            value={iconStyle.value}
            onChange={handleOnChangeStyle}
            inputProps={{'aria-label': 'Without label'}}
            IconComponent={KeyboardArrowDownIcon}
            sx={{
                border: "1px solid #ced4da",
                width: `100%`,
                '& legend': {display: 'none'},
                '& fieldset': {
                    top: 0,
                    border: `none`,
                },
                '& > .MuiSelect-select': {
                    padding: `6px 8px`
                }
            }}
            MenuProps={{
                PaperProps: {
                    sx: {
                        border: "1px solid #ced4da",
                        height: "200px",
                        marginTop: "8px",
                        "& .MuiMenuItem-root.Mui-selected": {
                            backgroundColor: "#4E7FA7!important",
                            '& .MuiTypography-root': {
                                color: `#ffffff`,
                            }
                        },
                        "& .MuiMenuItem-root:hover": {
                            backgroundColor: "#DEEBFF",
                            '& .MuiTypography-root': {
                                // color: `#ffffff`,
                            }
                        },
                        "& .MuiMenuItem-root.Mui-selected:hover": {
                            // backgroundColor: "#014780!important",
                            '& .MuiTypography-root': {
                                color: `#ffffff`,
                            }
                        }
                    }
                },
                MenuListProps: {
                    sx: {
                        padding: 0
                    }
                },
            }}
        >
            {iconsStyles}
        </Select>
    )
}